import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgArrowLeft(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.01783 14.7501L13.7678 8.00019L12 6.23242L3.11612 15.1163C2.8817 15.3507 2.75 15.6687 2.75 16.0002C2.75 16.3317 2.8817 16.6497 3.11612 16.8841L12 25.768L13.7678 24.0002L7.0177 17.2501L29.25 17.2501V14.7501L7.01783 14.7501Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgArrowLeft);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
